// extracted by mini-css-extract-plugin
export default {"errorMessage":"editProfile_errorMessage__B85y2"};